import { render } from "./ModalAttribute.vue?vue&type=template&id=2e68785b"
import script from "./ModalAttribute.vue?vue&type=script&lang=js"
export * from "./ModalAttribute.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__